<template>
    <div class="access-container">
        <div class="icon mt-2">
            <svg class="acesso-negado">
                <use :xlink:href="require('@/assets/img/icons/shield-lock.svg') + '#layer'"></use>
            </svg>
        </div>
        <div class="texto mb-4 px-2 has-text-centered">
            <p v-if="!userActive">
                {{ $t('usuario-inativado') }}
            </p>
            <p v-else-if="userActive && titleInner != null">
                {{ $t('sem-permissao-de-acesso-tela') + $t(titleInner) }}
            </p>
            <p v-else>
                {{ $t('sem-permissao-de-acesso') }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccessDenied',

    props: {
        title: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            titleInner: null,
            userActive: true,
        };
    },
    created() {
        if (this.title != null) {
            this.titleInner = this.title;
        } else if (this.$route.params.tela != undefined) {
            this.titleInner = this.$route.params.tela;
        }
        // this.userActive = this.userIsActive();
    },
};
</script>

<style lang="scss" scoped>
.access-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .texto p {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        color: $text-color;
        margin-top: 10px;
    }

    .icon {
        width: 150px;
        height: 150px;

        .acesso-negado {
            fill: $text-color;
            width: 150px;
            height: 150px;
        }
    }
}
</style>
